import { Component, useEffect } from "react";
import { MotionConfig } from "framer-motion";
import "@/App.css";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { ChoiceStrip } from "@/components/landing/ChoiceStrip";
import { Ticker } from "@/components/landing/Ticker";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Features } from "@/components/landing/Features";
import { DemoDashboard } from "@/components/landing/DemoDashboard";
import { Compatibility } from "@/components/landing/Compatibility";
import { ParentPanel } from "@/components/landing/ParentPanel";
import { PrivacySection } from "@/components/landing/PrivacySection";
import { IosTeaser } from "@/components/landing/IosTeaser";
import { VipCallout } from "@/components/landing/VipCallout";
import { SeoContent } from "@/components/landing/SeoContent";
import { FinalCta } from "@/components/landing/FinalCta";
import { ShareSection } from "@/components/landing/ShareSection";
import { Footer } from "@/components/landing/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { VARIANT } from "@/constants/links";
import { getAnalyticsConsent, loadGoogleAnalytics } from "@/lib/googleAnalytics";
import { track } from "@/lib/tracker";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center p-10 text-center font-sans text-slate-700">
          Qualcosa è andato storto. Ricarica la pagina.
        </div>
      );
    }
    return this.props.children;
  }
}

const isVip = VARIANT === "vip";
let lastTrackedLocation = "";

export default function App() {
  useEffect(() => {
    const trackPage = () => {
      if (
        getAnalyticsConsent() !== "granted" ||
        lastTrackedLocation === window.location.href
      )
        return;
      lastTrackedLocation = window.location.href;
      void loadGoogleAnalytics();
      track("view");
    };
    trackPage();
    window.addEventListener("guardian-analytics-consent-change", trackPage);
    return () =>
      window.removeEventListener("guardian-analytics-consent-change", trackPage);
  }, []);

  return (
    <ErrorBoundary>
      {/* 2026-10-13 — Accessibilità: `reducedMotion="user"` fa sì che
          framer-motion disattivi da solo le animazioni di transform/layout per
          gli utenti con prefers-reduced-motion (le animazioni opacity restano,
          comportamento standard accessibile). Integra la media query CSS in
          index.css che neutralizza invece le animazioni CSS (marquee/float). */}
      <MotionConfig reducedMotion="user">
        <div className="min-h-screen bg-background font-sans text-ink" style={{ overflowX: "clip" }}>
        <a className="gf-skip" href="#contenuto">Salta al contenuto</a>
        <Navbar />
        <main id="contenuto">
          <Hero />
          {!isVip && <ChoiceStrip />}
          <Ticker />
          <HowItWorks />
          <Features />
          {/* 2026-10-08 VIP: esposizione prodotto stile ClevGuard.
              DemoDashboard = riproduzione della dashboard con dati dimostrativi
              e categoria dati selezionabile; Compatibility = 3 passi di
              attivazione, tabella compatibilita' e prezzo. Entrambi restituiscono
              null nella variante standard, quindi guardianfamily.it resta invariato. */}
          <DemoDashboard />
          <Compatibility />
          <SeoContent />
          <ParentPanel />
          <PrivacySection />
          {isVip ? (
            <div className="h-0" aria-hidden="true" />
          ) : (
            <>
              <VipCallout />
              <IosTeaser />
            </>
          )}
          <FinalCta />
          {!isVip && <ShareSection />}
        </main>
        <Footer />
        <CookieConsent />
      </div>
      </MotionConfig>
    </ErrorBoundary>
  );
}
